import React, { type ComponentProps, type ReactElement } from 'react';

import type { HardBreak as OriginalHardBreak } from '@atlaskit/renderer/nodes';

import type { LightNodeProps } from '../LightNodeObserver.ts';

export const HardBreak = ({
	forceNewLine = false,
	lightNodeRef,
}: ComponentProps<typeof OriginalHardBreak> & LightNodeProps): ReactElement => (
	<>
		<br ref={lightNodeRef} />
		{forceNewLine && <br />}
	</>
);
